import React from 'react';

import * as Sentry from '@sentry/react';

import { ErrorPage400 } from '../ErrorPage/ErrorPage400';

type ErrorBoundaryProps = {
  children: React.ReactNode;
};

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, componentStack, eventId }) => (
        <ErrorPage400
          error={(error as string)?.toString()}
          componentStack={componentStack}
          eventId={eventId}
        />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};
